import HeroHeading from 'components/hero-heading';
import { theme } from 'styles/configure-theme';

export const StyledHeroHeading = HeroHeading.withConfig({
  color: theme.token('text-reversed'),
});
